import React, { useEffect, useRef, useState } from "react";
import "./NewLaunchGames.css";
import Helper from "../../helper";
import axios from "axios";
import Appconfig from "../../config/config";
import { toast } from "react-toastify";
import Login from "../Login/Login";

const NEW_LAUNCH_GAMES = [
  {
    id: "new-launch-1",
    name: "New Launch Game 1",
    image: "/Images/new-launch-games/17650471456386831.png",
  },
  {
    id: "new-launch-2",
    name: "New Launch Game 2",
    image: "/Images/new-launch-games/17728789917863910.png",
  },
  {
    id: "new-launch-3",
    name: "New Launch Game 3",
    image: "/Images/new-launch-games/17765061734682106.png",
  },
  {
    id: "new-launch-4",
    name: "New Launch Game 4",
    image: "/Images/new-launch-games/17803165268096870.png",
  },
  {
    id: "new-launch-5",
    name: "New Launch Game 5",
    image: "/Images/new-launch-games/17901633135650179.png",
  },
  {
    id: "new-launch-6",
    name: "New Launch Game 6",
    image: "/Images/new-launch-games/17817806877791035.png",
  },
  {
    id: "new-launch-7",
    name: "New Launch Game 7",
    image: "/Images/new-launch-games/17828558279261908.png",
  },
  {
    id: "new-launch-8",
    name: "New Launch Game 8",
    image: "/Images/new-launch-games/17847186738873673.png",
  },
  {
    id: "new-launch-9",
    name: "New Launch Game 9",
    image: "/Images/new-launch-games/17878289475027879.png",
  },
  {
    id: "new-launch-10",
    name: "New Launch Game 10",
    image: "/Images/new-launch-games/17892511534134535.png",
  },
  {
    id: "new-launch-11",
    name: "New Launch Game 11",
    image: "/Images/new-launch-games/17893039599281160.png",
  },
];

const NewLaunchGames = () => {
  const trackRef = useRef(null);

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const userInfo = Helper();

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false);
  };

  const CreateAndLaunchWCOCasino = async (
    providerCode,
    gameCode,
    type = null,
  ) => {
    if (!userInfo?._id || !userInfo?.user_name) {
      setShowLoginPopup(true);
      return;
    }

    if (!providerCode || !gameCode) {
      toast.error("Game configuration is missing.", {
        autoClose: 2000,
      });
      return;
    }

    const userData = {
      user_id: userInfo._id,
      user_name: userInfo.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: providerCode,
      game_code: gameCode,
      type,
    };

    try {
      const response = await axios({
        method: "post",
        url: `${Appconfig.casinoUrl}wco/login`,
        headers: {
          "Content-Type": "application/json",
        },
        data: userData,
      });

      const status = response?.data?.status?.code;
      const launchURL = response?.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.open(launchURL, "_self");
        return;
      }

      toast.error(response?.data?.status?.message || "Game Not Found.", {
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.status?.message ||
          "Unable to launch casino game.",
        { autoClose: 2000 },
      );
    }
  };

  useEffect(() => {
    const track = trackRef.current;

    if (!track) {
      return undefined;
    }

    const moveToNextGame = () => {
      const firstCard = track.querySelector(".new-launch-games-card");

      const cardWidth = firstCard?.offsetWidth || 0;
      const gap = 2;
      const originalGamesWidth = track.scrollWidth / 2;

      /*
       * Duplicate list start hote hi same original position par
       * invisible reset hoga.
       */
      if (track.scrollLeft >= originalGamesWidth) {
        track.scrollLeft -= originalGamesWidth;
      }

      track.scrollBy({
        left: cardWidth + gap,
        behavior: "smooth",
      });
    };

    /*
     * Har 2.5 seconds me ek card smooth move hoga.
     * Isme slide ke baad visible pause/gap milega.
     */
    const intervalId = window.setInterval(moveToNextGame, 2500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <section className="new-launch-games" aria-label="New launch games">
      <h2 className="new-launch-games-title">NEW LAUNCH</h2>

      <div ref={trackRef} className="new-launch-games-track">
        {[...NEW_LAUNCH_GAMES, ...NEW_LAUNCH_GAMES].map((game, index) => (
          <button
            key={`${game.id}-${index}`}
            type="button"
            className="new-launch-games-card"
            aria-label={`Play ${game.name}`}
            onClick={() =>
              CreateAndLaunchWCOCasino(
                game.providerCode,
                game.gameCode,
                game.type ?? null,
              )
            }
          >
            <img src={game.image} alt={game.name} loading="lazy" />
          </button>
        ))}
      </div>

      {showLoginPopup && <Login onClose={handleLoginPopupClose} />}
    </section>
  );
};

export default NewLaunchGames;
